import React from "react";
import { Image, Responsive, Grid, Icon, GridColumn } from "semantic-ui-react";
import Slider from "react-slick";
import { sliderArrowRight, sliderArrowLeft } from "../assets/Assets";
import { mainIp } from "../API/API";

class SliderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.dickref = React.createRef();
    this.slider = [];
    this.state = { activeSlide: 1 };
    this.renderInDesktop = this.renderInDesktop.bind(this);
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  renderInDesktop() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
      beforeChange: (current, next) => {
        if (next <= 0) {
          next = 1;
        }else{
          next = next + 1;
        }
        this.setState({ activeSlide: next });
      }
    };
    return (
      <div
      style={{
        overflow:"hidden",
        height:"80vh",
      }}>
        <div align="center" style={{}}>
          <Slider ref={c => (this.slider = c)} {...settings}>
            {this.props.slider.map((data, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      width: "100%",
                      height: "80vh",
                      backgroundImage: "url(" + mainIp + data.result + ")",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat"
                    }}
                  />
                </div>
              );
            })}
          </Slider>
        </div>

        <div
          style={{
            marginTop: "-100px",
            position: "relative",
            fontSize: "18px",
            cursor: "pointer"
          }}
        >
          <div className="SButton2">
            <div>
              <Image
                src={sliderArrowLeft}
                style={{ cursor: "pointer" }}
                width={30}
                height={30}
                onClick={this.previous}
              />
            </div>
            <div
              style={{
                marginTop: "15px",
                fontSize: "1rem"
              }}
            >
              {this.state.activeSlide} /{" "}
              {Object.keys(this.props.slider).length}
            </div>
            <div>
              <Image
                src={sliderArrowRight}
                style={{ cursor: "pointer" }}
                width={30}
                height={30}
                onClick={this.next}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInTablet() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
      beforeChange: (current, next) => {
        if (next <= 0) {
          next = 1;
        }else{
          next = next + 1;
        }
        this.setState({ activeSlide: next });
      }
    };
    return (
      <div style={{
        overflow:"hidden"
      }}>
        <div align="center" style={{}}>
          <Slider ref={c => (this.slider = c)} {...settings}>
            {this.props.slider.map((data, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      width: "100%",
                      height: "60vh",
                      backgroundImage: "url(" + mainIp + data.result + ")",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat"
                    }}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }

  renderInMobile() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: false,
      beforeChange: (current, next) => {
        if (next <= 0) {
          next = 1;
        }else{
          next = next + 1;
        }
        this.setState({ activeSlide: next });
      }
    };
    return (
      <div style={{
        overflow:"hidden"
      }}>
        <div align="center" style={{}}>
          <Slider ref={c => (this.slider = c)} {...settings}>
            {this.props.slider.map((data, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      width: "100%",
                      height: "40vh",
                      backgroundImage: "url(" + mainIp + data.result + ")",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center"
                    }}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

export default SliderComponent;
